import { useCallback, useRef, useState } from 'react';

// eslint-disable-next-line
const useLongPress = (onLongPress: { (): void }, { shouldPreventDefault = true, delay = 300 } = {}): any => {
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const timeout = useRef<NodeJS.Timeout>();
  // eslint-disable-next-line
  const target = useRef<any>();

  const start = useCallback(
    event => {
      if (shouldPreventDefault && event.target) {
        event.target.addEventListener('touchend', preventDefault, {
          passive: false,
        });
        target.current = event.target;
      }
      timeout.current = setTimeout(() => {
        onLongPress();
        setLongPressTriggered(true);
      }, delay);
    },
    [onLongPress, delay, shouldPreventDefault],
  );

  const clear = useCallback(
    (event, shouldTriggerClick = true) => {
      timeout.current && clearTimeout(timeout.current);
      // eslint-disable-next-line
      shouldTriggerClick && !longPressTriggered;
      setLongPressTriggered(false);
      if (shouldPreventDefault && target.current) {
        target.current.removeEventListener('touchend', preventDefault);
      }
    },
    [shouldPreventDefault, longPressTriggered],
  );

  return {
    // eslint-disable-next-line
    onMouseDown: (e: any) => start(e),
    // eslint-disable-next-line
    onTouchStart: (e: any) => start(e),
    // eslint-disable-next-line
    onMouseUp: (e: any) => clear(e),
    // eslint-disable-next-line
    onMouseLeave: (e: any) => clear(e, false),
    // eslint-disable-next-line
    onTouchEnd: (e: any) => clear(e)
  };
};

// eslint-disable-next-line
const isTouchEvent = (event: any) => {
  return 'touches' in event;
};

// eslint-disable-next-line
const preventDefault = (event: any) => {
  if (!isTouchEvent(event)) return;

  if (event.touches.length < 2 && event.preventDefault) {
    event.preventDefault();
  }
};

export default useLongPress;
